// eslint-disable-next-line max-len
export const GOJS_LICENSE_KEY = '73f942eab66328a800ca0d2b113f69ee1bb37f3b9ed11ba75e5441f0ef0c6d173089ee7102818a9781af1af5187fc28ad4c36c7b9e1b016be166d38f44b684fce13f73b54308448ca35434d39faf7aa7fc2a21f3d0a574a3d97b93faf4a8c1';
